import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';

// Components
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { UnsavedChangesComponent } from './components/unsaved-changes/unsaved-changes.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LeftNavComponent } from './components/left-nav/left-nav.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { BreadCrumbComponent } from './components/bread-crumb/bread-crumb.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { GoogleAddressComponent } from './components/google-address/google-address.component';
import { AddRestaurantComponent } from './components/add-restaurant/add-restaurant.component';
import { AddOutletComponent } from './components/add-outlet/add-outlet.component';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';

// Pipes
import { GenderPipe, SafeUrlPipe, SafeHtmlPipe } from './pipes';

// Directives
import {
  DecimaNumberDirective,
  OnlyNumberDirective,
  ScrollTrackerDirective,
  DisableControlDirective,
  AlphanumericOnlyDirective,
  PhoneNumberFormatterDirective,
} from './directives';

const CommonModules = [
  CommonModule,
  FormsModule,
  HttpClientModule,
  ReactiveFormsModule,
  RouterModule,
  MaterialModule,
];

const CommonComponents = [
  ErrorPageComponent,
  LayoutComponent,
  LeftNavComponent,
  FooterComponent,
  HeaderComponent,
  BreadCrumbComponent,
  TimePickerComponent,
  AutoCompleteComponent,
  GoogleAddressComponent,
  AddRestaurantComponent,
  AddOutletComponent,
  DateRangeFilterComponent,
  ConfirmationDialogComponent,
];

const CommonPipes = [GenderPipe, SafeUrlPipe, SafeHtmlPipe];
const CommonDirectives = [
  DecimaNumberDirective,
  OnlyNumberDirective,
  ScrollTrackerDirective,
  DisableControlDirective,
  AlphanumericOnlyDirective,
  PhoneNumberFormatterDirective,
];

@NgModule({
  imports: [CommonModules],
  declarations: [CommonComponents, CommonPipes, CommonDirectives],
  exports: [CommonModules, CommonComponents, CommonPipes, CommonDirectives],
  providers: [DatePipe],
  entryComponents: [UnsavedChangesComponent],
})
export class SharedModule {}
